<template>
  <div class="childPannel">
    <div class="childPannel-box-item-block">
      <div class="childPannel-box-item-block-info">
        <span class="childPannel-box-item-block-info-label"></span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
@import url('./childPannel.scss');
</style>
